module.exports = __webpack_public_path__ + "static/media/Layer_3.fea438d9.png";